// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_HfO4w","tips-wrap":"tips-wrap_MgF6U"};